import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmPasswordValidator } from 'src/@order/commonData/confirm-password.validator';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.scss'],
})
export class ResetPasswordDialogComponent implements OnInit {
  form: FormGroup;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;
  passwordType = {
    type: '',
  };

  constructor(
    public _matDialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    private _fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this._fb.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(6),
            this.passwordStrengthValidator(),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: [ConfirmPasswordValidator('password', 'confirmPassword')],
      }
    );
  }

  public passwordTypeWeek(password): any {
    //weak
    const ALL_SMALL = /^(?:([a-z])*){6,}$/;
    const ALL_CAPITAL = /^(?:([A-Z])*){6,}$/;
    const ALL_NUMBER = /^(?:([0-9])*){6,}$/;

    //normal
    const ALL_SMALL_CAPITAL = /^(?:([A-Z])*([a-z])*){6,}$/;
    const ALL_CAPITAL_NUMBER = /^(?:([A-Z])*([0-9])*){6,}$/;
    const ALL_SMALL_NUMBER = /^(?:([a-b])*([0-9])*){6,}$/;

    //strong
    const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/;
    const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    // function passwordChecker = (password) => {
    if (password.length >= 6) {
      if (PASSWORD_REGEX.test(password)) {
        this.passwordType.type = 'Strong';
      } else if (
        ALL_SMALL.test(password) ||
        ALL_CAPITAL.test(password) ||
        ALL_NUMBER.test(password)
      ) {
        this.passwordType.type = 'Weak';
      } else if (
        ALL_SMALL_CAPITAL.test(password) ||
        ALL_CAPITAL_NUMBER.test(password) ||
        ALL_SMALL_NUMBER.test(password)
      ) {
        this.passwordType.type = 'Normal';
      } else {
        this.passwordType.type = 'Normal';
      }
    }
    // }
  }

  ngOnInit(): void {
    this.form.get('password').valueChanges.subscribe((res) => {
      if (res) {
        if (res.length >= 6) this.passwordTypeWeek(res);
      }
    });
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    } else {
      this._matDialogRef.close({ password: this.form.get('password').value });
    }
  }

  passwordStrengthValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) return null;

      const hasUpperCase = /[A-Z]/.test(value);
      const hasLowerCase = /[a-z]/.test(value);
      const hasNumberOrSpecial = /[\d\W]/.test(value); // number or special character

      const valid = hasUpperCase && hasLowerCase && hasNumberOrSpecial;

      return !valid ? { passwordStrength: true } : null;
    };
  }
}
